export default {
  'open-menu': 'Menü öffnen',
  'close-menu': 'Schließen',
  'editorial-staff': 'Redaktion',
  about: 'Das Sind Wir',
  shopLink: 'Eine Welt der Möglichkeiten',
}
